// 1:1 port from age-of-mcp v3 flag — a banner you see across the map: one
// tapered oak pole topped with a gold finial, flying a big bold trade-red
// banner whose outer panel kinks back around y to read as a wave.
import { defineModel, styleV3, type Part } from "../../lib";

const { TIMBER, STONE_DK, ROOF_TRADE, ROOF_PRECIOUS, cyl, slab, poles, box } = styleV3;

const BASE   = 0.04;          // a thin ground pad
const POLE_H = 0.74;

function pad(): Part {
  return slab(0.18, 0.18, STONE_DK, BASE);
}

// The tapered pole, `h` tall.
function pole(h: number): Part {
  return cyl(0.022, 0.03, h, 6, TIMBER, [0, BASE + h / 2, 0]);
}

function partsFor(s: number): Part[] {
  if (s <= 0) return [pad()];
  if (s === 1) return [pad(), pole(0.26), ...poles(0.18, 0.18, 0.3)];
  if (s === 2) return [pad(), pole(0.55), ...poles(0.18, 0.18, 0.55)];

  const top = BASE + POLE_H;          // 0.78
  return [
    pad(),
    pole(POLE_H),
    // Gold finial at the masthead.
    cyl(0, 0.035, 0.07, 4, ROOF_PRECIOUS, [0, top + 0.035, 0]),
    // The big banner: a main panel plus a kinked outer panel — the wave.
    box(0.3, 0.2, 0.018, ROOF_TRADE, [0.17, top - 0.13, 0]),
    box(0.14, 0.2, 0.018, ROOF_TRADE, [0.37, top - 0.13, 0.03], [0, -0.5, 0]),
  ];
}

export const flagV3 = defineModel({
  id: "flag-v3",
  tiles: { w: 1, h: 1 },
  batchId: "45-optimized",
  name: "Flag (v3)",
  tags: ["building","flag","low-poly","age-of-mcp","v3"],
  summary: "Low-poly flag.",
  description: "A tall pole flying a pennant, marking territory and inscribed with a short name or message.",
  author: "age-of-mcp",
  footprint: 0.1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => partsFor(0) },
    { id: "stage-1", label: "Lower", parts: () => partsFor(1) },
    { id: "stage-2", label: "Upper", parts: () => partsFor(2) },
    { id: "complete", label: "Complete", parts: () => partsFor(3) },
  ],
  animations: [],
});
